import { ASSIGNMENT_STATUS_FILTER_GROUPS } from "@tt-app/constants";

const assignmentGetters = {
  groupedAssignments(state: any, getters: any) {
    const { filteredAssignments } = getters;

    const assignmentsGroupedByMonth: any = {};

    filteredAssignments.forEach((assignment: any) => {
      const month = assignment.dueDate.getMonth() + 1;

      assignmentsGroupedByMonth[month] = assignmentsGroupedByMonth[month] || [];
      assignmentsGroupedByMonth[month].push(assignment);
    });

    return assignmentsGroupedByMonth;
  },
  filteredAssignments(state: any, getters: any, rootState: any) {
    const {
      assignment: { list },
      form: {
        assignment: {
          selectedStatusFilterIndex: { value: selectedStatusFilterIndex },
          selectedYearFilter: { value: selectedYearFilter }
        }
      }
    } = rootState;

    const selectedYear = parseInt(selectedYearFilter, 10);

    const schoolYearStartDate = new Date(selectedYear, 3, 1);
    const schoolYearEndDate = new Date(selectedYear + 1, 2, 31, 12, 59, 59);

    const filterStatuses = ASSIGNMENT_STATUS_FILTER_GROUPS[selectedStatusFilterIndex];

    const filteredList = list.filter((assignment: any) => {
      return (
        filterStatuses.includes(assignment.status) &&
        schoolYearStartDate <= assignment.dueDate &&
        assignment.dueDate <= schoolYearEndDate
      );
    });

    const sortedList = filteredList.sort((assignmentA: any, assignmentB: any) => {
      return (
        assignmentA.dueDate - assignmentB.dueDate ||
        assignmentA.startDate - assignmentB.startDate ||
        assignmentA.title.localeCompare(assignmentB.title)
      );
    });

    return sortedList;
  },
  assignmentYears(state: any) {
    const { list } = state;

    const years: any[] = [];
    list.forEach((assignment: any) => {
      const assignmentYear = assignment.dueDate.getFullYear();
      const assignmentSchoolYear = [1, 2, 3].includes(assignment.dueDate.getMonth() + 1)
        ? assignmentYear - 1
        : assignmentYear;
      years[assignmentSchoolYear] = true;
    });

    return Object.keys(years);
  },
  assignmentMonths(state: any, getters: any) {
    const { filteredAssignments } = getters;

    const months: any[] = [];

    filteredAssignments.forEach((assignment: any) => {
      months[assignment.dueDate.getMonth() + 1] = true;
    });

    return Object.keys(months);
  },
  monthsWithOverdue(state: any, getters: any) {
    const { filteredAssignments } = getters;

    const months: any[] = [];

    filteredAssignments.forEach((assignment: any) => {
      if (assignment.status === 4) {
        months[assignment.dueDate.getMonth() + 1] = true;
      }
    });

    return Object.keys(months);
  },
  loading(state: any) {
    return state.loading;
  }
};

export { assignmentGetters };
